import mutations from './mutations'
import actions from './actions'

const state = {
  member_revenue_data: [],
  volunteer_revenue_data: [],
  donations_revenue_data: [],
  residency_count:[],
  residency_bed_nights:[],
  residency_revenue:[],
  residency_discounts:[],
  residency_tabular:[],
  vehicle_count:[],
  vehicle_revenue:[],
  vehicle_discounts:[],
  vehicle_bed_nights:[],
  bookings_revenue:[],
  bookings_discounts:[],
  bookings_total:[],
  transaction_data:[],
  transaction_total:{},
  discount_total:[],
  inventory_net_base:[],
  inventory_discount_net_base:[],
  inventory_tabular_data:[],
  inventory_count:[],
  inventory_bed_night:[],
  inventory_totals:{},
  residency_totals:{},
  vehicle_totals:{},
  vehicle_tabular:[],
  
  
}
export default {
  state, mutations, actions
}
